import React from 'react'
import ButtonCta from '@components/atoms/button-cta'
import PropTypes from 'prop-types'
import { RenderRichText } from '@components/renderers'
import { composeOptimizedImageUrl } from '@utils/composeOptimizedImageUrl'
import useStyles from './info-and-image-card.styles'

const InfoAndImageCard = (props) => {
  const {
    heading,
    subheading,
    richSummary,
    cardImage,
    ctaText,
    ctaLink,
    largeCardVariant,
  } = props

  const styles = useStyles({ largeCardVariant })

  const Summary = () => (
    <>
      {richSummary ? (
        <div className={styles.copySubheading}>
          <RenderRichText {...richSummary} />
        </div>
      ) : <h4 className={styles.copySubheading}>{subheading}</h4>
      }
    </>
  )

  return (
    <div className={styles.infoCard}>
      <img
        className={styles.img}
        src={composeOptimizedImageUrl(`${cardImage.url}?q=80`, 1200)}
        alt={cardImage.description}
      />
      <div className={styles.copyContainer}>
        <h3 className={styles.copyHeading}>{heading}</h3>
        <Summary />
        <ButtonCta className={styles.buttonCta} href={ctaLink} arrow>{ctaText}</ButtonCta>
      </div>
    </div>
  )
}

InfoAndImageCard.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  richSummary: PropTypes.object,
  cardImage: PropTypes.object,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  largeCardVariant: PropTypes.bool,
}

InfoAndImageCard.defaultProps = {}

export default InfoAndImageCard
